<template>
  <div class="session">
    <div style="width:99%;background-color:#ffffff">
      <el-input
        type="textarea"
        style="width:100%;margin:10px 0"
        :rows="2"
        placeholder="请输入内容"
        v-model="textarea"
      ></el-input>
      <el-row style="margin:0 0 10px;">
        <el-col :span="6" :offset="18">
          <el-button size="small" round type="primary" @click="huifu"
            >回复</el-button
          >
        </el-col>
      </el-row>
    </div>
    <div style="width:99%" v-for="item in huifuList" :key="item.tplk01">
      <el-card class="box-card" style="margin:5px 0px;position: relative;">
        <el-row>
          <el-col :span="8">
            <el-row>
              <el-col :span="12">
                <el-avatar
                  size="small"
                  :src="$store.state.baseUrl + item.user13"
                ></el-avatar>
              </el-col>
              <el-col :span="12" style="margin-top:5px">
                <p
                  style="width:60px;display:block;overflow:hidden;text-overflow:ellipsis;white-space: nowrap;"
                >
                  {{ item.user04 }}
                </p>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="11" style="margin-top:5px" :offset="5">{{
            item.tplk05N
          }}</el-col>
        </el-row>
        <hr />
        <br style="height:2px;" />
        <div>{{ item.tplk03 }}</div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { GetTopicContent, AddTopicContent } from "@/setAxios";
export default {
  name: "session",
  data() {
    return {
      textarea: "",
      huifuList: null
    };
  },
  props: {
    id: ""
  },
  watch: {
    id() {
      this.GetTopicContent();
    }
  },
  created() {
    // this.GetTopicContent();
  },
  methods: {
    huifu() {
      let params = {
        tplk02: this.id,
        tplk03: this.textarea,
        tplk04: localStorage.id,
        tplk06: localStorage.xid
      };
      AddTopicContent(params).then(res => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "回复成功",
            duration: 1000
          });
          this.textarea = "";
          this.GetTopicContent();
        }
      });
    },
    GetTopicContent() {
      let params = {
        id: this.id
      };
      GetTopicContent(params).then(res => {
        //(res)
        this.huifuList = res.Data;
      });
    }
  }
};
</script>

<style lang="less">
.session {
  width: 340px;
  height: 100%;
  border: 1px solid #eee;
  // padding: 5px 5px 130px;
  padding: 0 5px;
  box-sizing: border-box;
  overflow: auto;
}
</style>
